import React from 'react';
import styled from 'styled-components';

const HeaderContainer = styled.div`
  text-align: center;
  margin-bottom: 32px;
  position: relative;
`;

const Title = styled.h1`
  color: var(--text-primary);
  font-size: 2.5rem;
  font-weight: 600;
  margin: 0;
  letter-spacing: -0.02em;
  transition: color 0.3s ease;
`;

const Subtitle = styled.p`
  color: var(--text-secondary);
  font-size: 1rem;
  margin: 8px 0 0 0;
  font-weight: 400;
  transition: color 0.3s ease;
`;

const LogoutButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  background: transparent;
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    color: #ef4444;
    border-color: #ef4444;
  }
`;

const Header: React.FC = () => {
  const handleLogout = () => {
    sessionStorage.removeItem('auth_token');
    window.location.reload();
  };

  return (
    <HeaderContainer>
      <LogoutButton onClick={handleLogout}>Выйти</LogoutButton>
      <Title>Base DCA Trading Bot</Title>
      <Subtitle>Manage multiple wallets with different trading strategies on Base network.</Subtitle>
    </HeaderContainer>
  );
};

export default Header;
